import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { NewAmlCheckButton } from "./NewAmlCheck";
import { CommonTable } from "components";
import { useStores } from "stores";
import { getColumns } from "./getColumns";
import { CompanyRoleFilters } from "./CompanyRoleFilters";
import { CheckLimit } from "./CheckLimit";
import { shouldShowResetButton } from "utils";

export const AmlChecksPage = observer(() => {
  const { amlCheckList, user } = useStores();

  const { isCustomer, isProvider, isOperator, isLPRiskManager } = user.roles;

  return (
    <Flex vertical gap="large">
      <Flex justify="space-between" align="center">
        <Flex vertical>
          <Typography.Title className="margin-none">AML проверки</Typography.Title>
          {(isCustomer || isProvider || isLPRiskManager) && <CheckLimit />}
        </Flex>
        <NewAmlCheckButton />
      </Flex>
      <CommonTable
        store={amlCheckList}
        updateWithInterval
        columns={getColumns(user, amlCheckList)}
        customShouldShowResetButton={() => shouldShowResetButton(amlCheckList, ["companyRole"])}
        whiteBox
        widgets={{
          search: true,
          date: false,
        }}
        additionalElements={isOperator && <CompanyRoleFilters />}
        rowKey={"amlId"}
      />
    </Flex>
  );
});
